module.exports = __webpack_public_path__ + "static/media/ST5-BG2.131f52e4.jpg";